import styled from 'styled-components'

import { COLOURS } from 'resources'

export const Description = styled.div`
  font-size: 18px;
  margin: 10px 0 30px;
`

export const PurpleText = styled.span`
  color: ${COLOURS.secondaryPurple1};
  word-break: break-word;
`

export const ErrorMessage = styled.div`
  color: ${COLOURS.secondaryRed1};
  text-align: center;
`
